import HP from "../host";
import { PaginationParamsType } from "../types/common";
import { ApiService } from "./API";
const api = new ApiService(`${HP.request}://${HP.host}/api/v1`);
const StudentInstructorService = {
  create: async (body: object) => {
    return await api.post(`/student-instructor/create`, body);
  },

  getInstructors: async (params: PaginationParamsType) => {
    return await api.get(
      `/student-instructor/instructors?page=${params.page}&per_page=${
        params.per_page
      }&query=${params.query || ""}`
    );
  },

  getStudents: async (params: PaginationParamsType) => {
    return await api.get(
      `/student-instructor/students?page=${params.page}&per_page=${
        params.per_page
      }&query=${params.query || ""}`
    );
  },

  remove: async (id: string) => {
    return await api.delete(`/student-instructor/remove/${id}`);
  },
};
export default StudentInstructorService;
